module.exports = __webpack_public_path__ + "img/010.363cda8c.jpg";